import socialSecurityDataComponent from './socialSecurityData.component';

let socialSecurityDataModule = angular.module('socialSecurityData', [
])

.component('socialSecurityData', socialSecurityDataComponent)

.name;

export default socialSecurityDataModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityCard/socialSecurityData/socialSecurityData.js